import { Button, CircularProgress, Stack, SvgIcon, Typography } from "@mui/material"
import { FC, useMemo } from "react"
import { EmptyPage } from "../../../category/categoryEmpty/ui";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../locales/tokens";
import { paths } from "../../../../../paths";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { getStyles } from "./styles";
import { useQuizList } from "../presenter/useQuizList";
import { SearchInput } from "../../../../../ui-kit/searchInput/searchInput";
import { TabsChanger } from "../../../../../ui-kit/tabsChanger";
import { Filters } from "../../../../../ui-kit/listFilters";
import { QuizTable } from "./components/quizTable";

export const Quiz: FC = () => {
    const { t } = useTranslation();
    const styles = useMemo(() => getStyles(), []);
    const { searchText, handleSearchQuizText, filters, handleTabsChange, orgStructure, changeStatus, resetFilters, handleDateChange, onSelectInitiator,
        onChangeInitiator, handlePageChange, handleStatus, handleDelete, handleUploadReport, pageAmount, quizList, isProccessQuiz, scrollRef } = useQuizList();

    return (
        <Stack m={2}>
            <Stack>
                <Stack direction='row' justifyContent='space-between'>
                    <Typography variant="h5" fontWeight={600}>
                        {t(tokens.quiz.quizList)}
                    </Typography>
                    <Button
                        startIcon={(<SvgIcon><AddIcon /></SvgIcon>)}
                        variant="contained"
                        sx={styles.createBtn}
                        component={Link}
                        to={paths.dashboard.content.quiz.create}
                    >
                        {t(tokens.common.create)}
                    </Button>
                </Stack>
                <Stack mt={3}>
                    <SearchInput
                        searchText={searchText}
                        label={t(tokens.quiz.searchByName)}
                        handleSearch={handleSearchQuizText}
                        size="small"
                    />
                </Stack>
                <Filters
                    filters={filters}
                    orgStructure={orgStructure}
                    changeStatus={changeStatus}
                    resetFilters={resetFilters}
                    handleDateChange={handleDateChange}
                    onSelectInitiator={onSelectInitiator}
                    onChangeInitiator={onChangeInitiator}
                />
                <TabsChanger
                    tab={filters.tab}
                    handleTabsChange={handleTabsChange}
                />
            </Stack>
            {quizList?.length > 0 &&
                <QuizTable
                    scrollRef={scrollRef}
                    page={filters.page}
                    quizList={quizList}
                    handlePageChange={handlePageChange}
                    pageAmount={pageAmount}
                    handleStatus={handleStatus}
                    handleDelete={handleDelete}
                    handleUpload={handleUploadReport}
                />
            }
            {(!quizList?.length && isProccessQuiz) &&
                <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={styles.progress}
                >
                    <CircularProgress color="primary" />
                </Stack>
            }
            {(!quizList?.length && !isProccessQuiz) &&
                <Stack>
                    <EmptyPage
                        title={t(tokens.quiz.emptyListTitle)}
                        description={t(tokens.quiz.emptyListDesc)}
                    />
                </Stack>
            }
        </Stack>
    )
};